import type { SuperComment } from '@creator/sdk/modules/super-comment/super-comment.model';
import type { Timestamp } from 'firebase/firestore/lite';

export interface BaseContentEntity {
    id: string;
    tokenName: string;
    createdAt: Timestamp;
    updatedAt?: Timestamp;
    publisherId: string;
    publisherName: string;
    publisherProfileName?: string;
    publisherSlugUrl?: string;
    reactionsCount: Map<string, number>;
    totalReactions: number;
    lastReactorsNames: string[];
    lastActivity: Timestamp;
    tipAmount: number;
    totalTips: number;
    lastTippersNames: string[];
    tippingUsers: Map<string, number>;
    tippingUserNames: Map<string, number>;
    totalTippers: number;
}

export enum CommentStatus {
    PUBLISHED = 0,
    DELETED_BY_TOKEN_ADMIN = 1,
    DELETED_BY_PUBLISHER = 2,
    DELETED_BY_DOMAIN_ADMIN = 3,
    DELETED_BY_CATEGORY_ADMIN = 4,
    PENDING = 5,
}

export enum PostStatus {
    PUBLISHED = 0,
    DELETED_BY_TOKEN_ADMIN = 1,
    DELETED_BY_PUBLISHER = 2,
    DELETED_BY_DOMAIN_ADMIN = 3,
    DELETED_BY_CATEGORY_ADMIN = 4,
    PENDING = 5,
    PENDING_TRANSCRIPT = 6,
    PUBLISHED_UNLISTED = 7,
    PUBLISHED_SCHEDULED = 8,
    DRAFT = 9,
}

export type ContentEntity = Post | Comment | SuperComment;
export type ContentEntityType = 'Post' | 'Comment' | 'SuperComment';

export interface PostPollLastVoters {
    count: number;
    lastVoters: string[];
}

export interface Post extends BaseContentEntity {
    postId: string;
    slugUrl?: string;

    scTopId?: string;
    scTopAmount: number;
    scTotalAmount: number;
    scCount: number;

    externalArticleUrl?: string;
    externalArticleId?: string;

    domain: string;
    title: string;
    pollId?: string;
    postContent: string;

    scheduledAt?: Timestamp;
    scheduledTaskId?: string;
    status: PostStatus;
    numComments: number;

    totalViews?: number;
    totalImpressions?: number;
    isPinned?: boolean;
    pinnedTime?: Timestamp;
    flairs?: string[];
    flairIds?: string[];
    reason?: string;
    reasonText?: string;
    pollOptions?: string[];
    pollTotalVoters?: number;
    pollValues?: PostPollLastVoters;
    postTypes?: string[];

    isSyndicated?: boolean;
    syndicateUpdateTime?: boolean;

    moderationScore?: number;
    moderationContent?: string;

    createdByWhitelistedUser?: boolean;
    kind: 'community' | 'story';
    excerpt?: string;
    heroImage?: string;
    featuredImage?: string;
}

// Define the Comment interface extending BaseContentEntity
export interface Comment extends BaseContentEntity {
    postId: string;
    content: string;
    status: CommentStatus;

    replyToCommentId?: string;
    parentPublisherId?: string;
    path?: string;
    depth?: number;

    numReplies?: number;
}
